import styled from "@mui/system/styled";

export const Wrapper = styled("div")({
  textAlign: "center",
  margin: "25px 0",
});
export const Img = styled("img")({
  width: "88px",
  height: "33px",
});
export const P = styled("p")({
  margin: "0",
  padding: "8px 0",
});
